"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningTableBodyEmptyRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LearningTableBodyDescriptionCell_1 = require("./LearningTableBodyDescriptionCell");
const LearningTableBodyEmptyRow = ({ isMobile, columnQuantity, }) => {
    return ((0, jsx_runtime_1.jsx)("tbody", { className: "screen-reader-only hidden", children: (0, jsx_runtime_1.jsx)("tr", { className: "learning-table-body-description-row ", tabIndex: -1, children: (0, jsx_runtime_1.jsx)(LearningTableBodyDescriptionCell_1.LearningTableBodyDescriptionCell, { cellInfo: { description: '' }, buttonLabel: "-", isMobile: isMobile, isInvisible: true, columnQuantity: columnQuantity, isEmpty: true }) }) }));
};
exports.LearningTableBodyEmptyRow = LearningTableBodyEmptyRow;
